module.exports = __webpack_public_path__ + "img/logo.ab03bec4.png";